import * as React from 'react';

export const MoveIcon = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M19.1 7.7L17.7 9.1L20 11.4H13.4V4.8L15.7 7.1L17.1 5.7L12.4 1L7.7 5.7L9.1 7.1L11.4 4.8V11.4H4.8L7.1 9.1L5.7 7.7L1 12.4L5.7 17.1L7.1 15.7L4.8 13.4H11.4V20L9.1 17.7L7.7 19.1L12.4 23.8L17.1 19.1L15.7 17.7L13.4 20V13.4H20L17.7 15.7L19.1 17.1L23.8 12.4L19.1 7.7Z'
        fill='#3023AE'
      />
    </svg>
  );
};
